import React from "react";

import Logo from "../Navbar/Logo";
import Links from "../Navbar/Links";

interface Props {}

const Footer: React.FC<Props> = (props) => {
  return (
    <footer className="footer">
      <div className="footerContainer">
        <div>
          <Logo />
          <div className="mt-6 md:mt-4"></div>
          <Links />
        </div>

        <div className="mt-12 md:mt-0">
          <p className="text-white mb-4">Get latest updates</p>
          <div className="md:flex md:flex-row">
            <input type="text" placeholder="Email Address" className="footerInput" />
            <button className="buttonPrimary w-full md:w-1/3 p-2">Subscribe</button>
          </div>
        </div>
      </div>
      <hr className="footerLine" />
      <p className="footerCopyright">&copy; {new Date().getFullYear()} - AccelPlay all right reserved</p>
    </footer>
  );
};

export default Footer;
